/**
 * Trigger a browser file download for the given blob URL.
 * Revokes the object URL after 1 s (fire-and-forget cleanup).
 */
export const triggerDownload = (url: string, fileName: string): void => {
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();

  setTimeout(() => {
    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }, 1000);
};

/**
 * Open a Blob in a new browser tab (PDF / images) or trigger a download
 * for all other MIME types.
 *
 * The blob URL is always revoked after 60 seconds so it does not leak
 * across SPA navigation (beforeunload does not fire on React Router
 * transitions).
 */
export const openOrDownloadBlob = (blob: Blob, fileName: string): void => {
  const downloadUrl = window.URL.createObjectURL(blob);
  const isPdf = blob.type === "application/pdf";
  const isImage = blob.type.startsWith("image/");

  if (isPdf || isImage) {
    const newTab = window.open(downloadUrl, "_blank");

    if (!newTab || newTab.closed || typeof newTab.closed === "undefined") {
      // Pop-up was blocked — fall back to a normal download
      triggerDownload(downloadUrl, fileName);
    } else {
      // Schedule revocation regardless of how the user later navigates
      setTimeout(() => window.URL.revokeObjectURL(downloadUrl), 60_000);
    }
  } else {
    triggerDownload(downloadUrl, fileName);
  }
};
